import React from 'react';
import InternshipPlannerComingSoon from './pages/InternshipPlannerComingSoon';

// function App() {
//   return (
//     <AuthProvider>
//       <AppRoutes />
//     </AuthProvider>
//   );
// }


function App() {
  return (
    <InternshipPlannerComingSoon />
  );
}

export default App;